import app from "../../../main.js";

const state = {
  deskName: "",
  deskNumber: "",
  deskSipPhone: "external",
  phoneExt: "",
};

const mutations = {
  setDeskName(state, name) {
    state.deskName = name;
  },

  setDeskNumber(state, number) {
    state.deskNumber = number;
  },

  setDeskSipPhone(state, sipPhone) {
    state.deskSipPhone = sipPhone;
  },

  setPhoneExt(state, phoneExt) {
    state.phoneExt = phoneExt;
  },
};

const actions = {
  createPhoneExt({ commit, state, getters, rootGetters }) {
    if (!state.deskNumber) {
      commit("setPhoneExt", null);
    } else {
      const callCenterId = rootGetters["app/callCenter"]?.id;
      const isSip = getters.isSipExternal ? "0" : "1";
      const phoneExt = `${callCenterId}${isSip}${state.deskNumber}`;
      commit("setPhoneExt", phoneExt);
    }
  },
  getPhoneExt({ state, dispatch }) {
    if (state.phoneExt && !state.phoneExt.includes("sin")) {
      return Promise.resolve(state.phoneExt);
    }

    return new Promise((resolve) => {
      app
        .$confirm(
          "Para poder usar la telefonía necesitas configurar tu extensión",
          "Extensión no configurada",
          {
            confirmButtonText: "Configurar extensión",
            cancelButtonText: "Cancelar",
          }
        )
        .then(() => {
          dispatch("app/setShowExtensionSetupModal", true, { root: true });
          resolve(false);
        })
        .catch(() => {
          resolve(false);
        }); // just ignore if the user cancel the action
    });
  },
};

const getters = {
  deskName(state) {
    return state.deskName;
  },

  deskNumber(state, getters, rootGetters) {
    if (!state.deskNumber && state.phoneExt) {
      const ccId = rootGetters.app.callCenter?.id?.toString();
      return state.phoneExt.slice(ccId.length + 1);
    }
    return state.deskNumber;
  },

  deskSipPhone(state) {
    if (!state.deskSipPhone && state.phoneExt) {
      const ccId = rootGetters.app.callCenter?.id?.toString();
      const isSip = state.phoneExt.charAt(ccId.length);
      if (isSip === "0") {
        return "external";
      } else if (isSip === "1") {
        return "sip";
      }
    }
    return state.deskSipPhone;
  },

  phoneExt(state) {
    return state.phoneExt;
  },

  isSipExternal(state) {
    return state.deskSipPhone === "external";
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
